import React, { Component } from 'react';
import API from '../api';
import Groups from './Groups';
import Events from './Events';
import People from './People';
import Registrations from './Registrations';
import Sermons from './Sermons';
import DetailModal from './DetailModal';

const COMPONENTS = {
  groups: Groups,
  events: Events,
  people: People,
  registrations: Registrations,
  sermons: Sermons,
};

// Maps section type to detail item type
const DETAIL_TYPES = {
  groups: 'group',
  events: 'event',
  sermons: 'message',
};

class PlanningCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      error: null,
      studioMode: false,
      settings: props.settings || {},
      detailItem: null,
    };
    this._handleSettingsUpdate = this._handleSettingsUpdate.bind(this);
    this._handleItemClick = this._handleItemClick.bind(this);
    this._handleCloseDetail = this._handleCloseDetail.bind(this);
  }

  componentDidMount() {
    // Detect Studio iframe
    try {
      if (window.location !== window.parent.location &&
          window.parent.location.href.indexOf('studio.') > -1) {
        this.setState({ studioMode: true });
        this._listenForSettingsUpdates();
      }
    } catch (e) {
      // Cross-origin — not in Studio
    }

    // Always fetch from API — same codepath for all contexts
    this.fetchData();
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this._containerEl) {
      this._containerEl.removeEventListener('pco-settings-update', this._handleSettingsUpdate);
    }
  }

  _findContainer() {
    const el = document.querySelector(`.pco-content[data-pco-type="${this.props.sectionType}"]`);
    this._containerEl = el;
    return el;
  }

  _listenForSettingsUpdates() {
    const container = this._findContainer();
    if (container) {
      container.addEventListener('pco-settings-update', this._handleSettingsUpdate);
    }
  }

  _handleSettingsUpdate(e) {
    if (this._unmounted) return;
    const newSettings = e.detail || {};
    this.setState({ settings: { ...newSettings, _studioMode: true } });
  }

  _handleItemClick(itemType, itemId) {
    if (this.state.studioMode) return;
    this.setState({ detailItem: { itemType, itemId } });
  }

  _handleCloseDetail() {
    this.setState({ detailItem: null });
  }

  fetchData() {
    const { siteUniqueName, sectionType, settings, host, protocol } = this.props;
    const p = protocol || 'https';
    const h = host || 'orbitalsites.com';

    const params = {};
    if (settings) {
      if (settings['pco-count'] && settings['pco-count'] !== 'all') params.count = settings['pco-count'];
      if (settings['pco-group-type'] && settings['pco-group-type'] !== 'all') params.group_type = settings['pco-group-type'];
      if (settings['pco-membership-type'] && settings['pco-membership-type'] !== 'all') params.membership_type = settings['pco-membership-type'];
    }

    API.getPcoData(p, h, siteUniqueName, sectionType, params)
      .then(json => {
        if (this._unmounted) return;
        this.setState({ data: json.data || [], loading: false });
        document.dispatchEvent(new CustomEvent('section-content-loaded'));
      })
      .catch(err => {
        if (this._unmounted) return;
        console.error('PCO fetch error:', err);
        this.setState({ error: 'Failed to load content', loading: false });
        document.dispatchEvent(new CustomEvent('section-content-loaded'));
      });
  }

  render() {
    const { sectionType, siteUniqueName, host, protocol } = this.props;
    const { data, loading, error, studioMode, settings, detailItem } = this.state;
    const SubComponent = COMPONENTS[sectionType];
    const detailType = DETAIL_TYPES[sectionType];

    const effectiveSettings = studioMode
      ? { ...settings, _studioMode: true }
      : (this.props.settings || {});

    return (
      <div className="pco-content-inner" data-pco-type={sectionType}>
        {loading && (
          <div className="pco-empty"><p>Loading...</p></div>
        )}
        {error && (
          <div className="pco-empty"><p>{error}</p></div>
        )}
        {!loading && !error && SubComponent && (
          <SubComponent
            data={data}
            settings={effectiveSettings}
            onItemClick={detailType ? (id) => this._handleItemClick(detailType, id) : null}
          />
        )}
        {detailItem && (
          <DetailModal
            itemType={detailItem.itemType}
            itemId={detailItem.itemId}
            siteUniqueName={siteUniqueName}
            host={host}
            protocol={protocol}
            onClose={this._handleCloseDetail}
          />
        )}
      </div>
    );
  }
}

export default PlanningCenter;
